import { StyledIncidents } from './Incidents.style';
import useIncidents from './useIncidents/useIncidents';
import useFilters from './useFilters/useFilters';
import useTableData from './useTableData/useTableData';
import GridChipFilterContainer from 'components/GridChipFilterContainer/GridChipFilterContainer';
import { TRACKING } from 'common/constants/constants';
import useTeamGitFilters from '../../hooks/useTeamGitFilters';

const Incidents = () => {
  const { incidents, fetchIncidents } = useIncidents();
  const filters = useFilters();
  useTeamGitFilters();
  const { rows, cols } = useTableData({ incidents });

  return (
    <StyledIncidents>
      <GridChipFilterContainer
        teamsFilterKey='filtered_teams'
        getData={fetchIncidents}
        data={incidents}
        tableData={() => rows}
        pageTag={TRACKING.PAGES.ACTIVITY}
        pageTabTag={TRACKING.PAGE_TABS.RELEASES}
        filterChipLabelMap={filters.chipLabelMap}
        columns={cols}
        skeletonColumns={filters.loadingSkeleton}
        getReqFilterBody={filters.getReqFilterBody}
        filtersConfig={filters.filtersConfig}
        filtersGroupMap={filters.filtersGroupMap}
        disablePointInHistory
        refreshOnDependencies={filters.refreshOnDependencies}
        sendAllContributorsTeamId={true}
      />
    </StyledIncidents>
  );
};

export default Incidents;
